export enum Role {
  Admin = 'Admin',
  Maintainer = 'Maintainer',
  Viewer = 'Viewer',
  ApplePayDomainAdder = 'ApplePayDomainAdder'
}
